import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useInteractionTracking, TRACKED_PAGES } from "@/hooks/useInteractionTracking";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "zh_session";

/** Sin cookies: un id anónimo de sesión que se borra al cerrar la pestaña. */
const sessionId = () => {
  try {
    let id = window.sessionStorage.getItem(KEY);
    if (!id) {
      id = Math.random().toString(36).slice(2) + Date.now().toString(36);
      window.sessionStorage.setItem(KEY, id);
    }
    return id;
  } catch { return "anon"; }
};

/** Registra cada página vista y cuánto tiempo se quedó, para la sección Datos del panel. */
export const useVisitTracking = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname.startsWith("/admin")) return undefined;
    const visitId = Math.random().toString(36).slice(2) + Date.now().toString(36);
    const startedAt = Date.now();
    const base = {
      visit_id: visitId, session: sessionId(), path: pathname,
      referrer: document.referrer || "", screen: window.innerWidth,
    };
    const send = (seconds, beacon) => {
      const body = JSON.stringify({ ...base, seconds });
      const url = `${API}/track/visit`;
      if (beacon && navigator.sendBeacon) {
        navigator.sendBeacon(url, new Blob([body], { type: "application/json" }));
      } else {
        fetch(url, { method: "POST", body, keepalive: true,
          headers: { "Content-Type": "application/json" } }).catch(() => {});
      }
    };

    send(0, false);
    const flush = () => send(Math.round((Date.now() - startedAt) / 1000), true);
    window.addEventListener("pagehide", flush);
    return () => {
      window.removeEventListener("pagehide", flush);
      flush();
    };
  }, [pathname]);
};

export const VisitTracker = () => {
  const { pathname } = useLocation();
  useVisitTracking();
  // mapa de calor de las páginas fijas; las de ruta lo hacen desde TourDetail
  useInteractionTracking(TRACKED_PAGES.includes(pathname) ? pathname : "");
  return null;
};
